import { connect } from 'react-redux';
import { openPanel } from 'services/custom-panels';
import ImageCard from './view';

const mapDispatchToProps = dispatch => ({
  dispatchCta: data => dispatch(openPanel(data)),
});

export default connect(null, mapDispatchToProps)(ImageCard);
